// Static SVG icons inlined as strings. Used via dom-helpers.setHtmlIcon.
// Never include user data here — these are constants only.

export const ICON_SPINNER = `
<svg viewBox="0 0 24 24" aria-hidden="true" class="animate-spin h-6 w-6 text-zinc-200">
  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" fill="none" opacity="0.25" />
  <path d="M12 2 a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="3" fill="none" stroke-linecap="round" />
</svg>
`;

export const ICON_WARN = `
<svg viewBox="0 0 24 24" aria-hidden="true" class="h-6 w-6 text-amber-400">
  <path fill="currentColor" d="M12 2 1 21h22L12 2zm0 6l8.5 14.5H3.5L12 8zm-1 4v4h2v-4h-2zm0 6v2h2v-2h-2z" />
</svg>
`;

export const ICON_ERROR = `
<svg viewBox="0 0 24 24" aria-hidden="true" class="h-6 w-6 text-rose-400">
  <circle cx="12" cy="12" r="10" fill="currentColor" />
  <path d="M9 9 l6 6 M15 9 l-6 6" stroke="white" stroke-width="2.4" stroke-linecap="round" />
</svg>
`;

export const ICON_INFO = `
<svg viewBox="0 0 24 24" aria-hidden="true" class="h-6 w-6 text-sky-400">
  <circle cx="12" cy="12" r="10" fill="currentColor" />
  <path d="M12 7 v2 M12 11 v6" stroke="white" stroke-width="2.4" stroke-linecap="round" />
</svg>
`;

export const ICON_UPLOAD = `
<svg viewBox="0 0 24 24" aria-hidden="true" class="h-6 w-6 text-zinc-200">
  <path d="M12 3 v12 M7 8 l5-5 l5 5" stroke="currentColor" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5 17 v3 h14 v-3" stroke="currentColor" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`;

export const ICON_FULLSCREEN = `
<svg viewBox="0 0 24 24" aria-hidden="true" width="20" height="20">
  <path d="M4 9 V4 H9 M20 9 V4 H15 M4 15 V20 H9 M20 15 V20 H15" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`;

export const ICON_CAMERA = `
<svg viewBox="0 0 24 24" aria-hidden="true" width="20" height="20">
  <path d="M9 4 l-2 3 H4 v13 h16 V7 h-3 l-2-3 z" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
  <circle cx="12" cy="13" r="4" stroke="currentColor" stroke-width="2" fill="none" />
</svg>
`;

export const ICON_RESET = `
<svg viewBox="0 0 24 24" aria-hidden="true" width="20" height="20">
  <path d="M4 12 a8 8 0 1 1 2.34 5.66" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" />
  <path d="M4 5 v6 h6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`;

export const ICON_PERF = `
<svg viewBox="0 0 24 24" aria-hidden="true" width="20" height="20">
  <path d="M12 3 v3 M19 7 l-2 2 M21 14 h-3 M3 14 h3 M7 9 l-2 -2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  <circle cx="12" cy="14" r="6" stroke="currentColor" stroke-width="2" fill="none" />
  <path d="M12 14 l3 -3" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
</svg>
`;

export const ICON_TOUR_PLAY = `
<svg viewBox="0 0 24 24" aria-hidden="true" width="14" height="14">
  <path d="M8 5 v14 l11-7 z" fill="currentColor" />
</svg>
`;

export const ICON_TOUR_PAUSE = `
<svg viewBox="0 0 24 24" aria-hidden="true" width="14" height="14">
  <path d="M6 4 h4 v16 h-4 z M14 4 h4 v16 h-4 z" fill="currentColor" />
</svg>
`;

export const ICON_SHARE = `
<svg viewBox="0 0 24 24" aria-hidden="true" width="20" height="20">
  <path d="M12 3 v12 M8 7 l4-4 l4 4" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M5 12 v8 h14 v-8" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
</svg>
`;

export const ICON_WALK = `
<svg viewBox="0 0 24 24" aria-hidden="true" width="20" height="20">
  <circle cx="13" cy="4" r="2" fill="currentColor" />
  <path d="M10 22 l3 -8 l-3 -3 l4 -3 l4 5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M10 14 l-3 -2" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" />
  <path d="M16 16 l-2 6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" />
</svg>
`;

export const ICON_MEASURE = `
<svg viewBox="0 0 24 24" aria-hidden="true" width="20" height="20">
  <path d="M2 17 L17 2 L22 7 L7 22 Z" stroke="currentColor" stroke-width="2" fill="none" stroke-linejoin="round" />
  <path d="M5 14 l1.5 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  <path d="M9 11 l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  <path d="M13 7 l2 2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
  <path d="M17 4 l1.5 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
</svg>
`;

export const ICON_XR = `
<svg viewBox="0 0 24 24" aria-hidden="true" width="20" height="20">
  <rect x="2" y="7" width="20" height="10" rx="2" stroke="currentColor" stroke-width="2" fill="none" />
  <circle cx="8" cy="12" r="1.5" fill="currentColor" />
  <circle cx="16" cy="12" r="1.5" fill="currentColor" />
</svg>
`;

export const ICON_CLOSE = `
<svg viewBox="0 0 24 24" aria-hidden="true" width="16" height="16">
  <path d="M6 6 l12 12 M6 18 L18 6" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" />
</svg>
`;
